import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators , FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatSnackBar } from '@angular/material';

import { OpcionModel } from '../Global/Opcion.model';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';

@Component({
	selector	: 'ReimpresionFacturaIndex',
	templateUrl : 'ReimpresionFacturaIndex.component.html'

})

export class ReimpresionFacturaIndexComponent  {

	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar:boolean;
	public btnEditar:boolean;
	public btnEliminar:boolean;
	public btnConsultar:boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //


	public form:FormGroup;
	public formErrors:any;

	public tipoReporte:number;
	public reporteRango:boolean;
	public reporteFecha:boolean;
	public mostrar:boolean;
	public valorRango1:string;
	public valorRango2:string;
	public valorFecha1:Date;
	public valorFecha2:Date;
	public listaPatrimonios:Array<OpcionModel>;
	public listaPrefijos:Array<OpcionModel>;
	public cnumcont:OpcionModel;
	public ciddoc:any;

	public ocultar: boolean = false;
	public mensaje: string = "";

	myControl = new FormControl();
	filteredOptions: Observable<OpcionModel[]>;

	constructor(private formBuilder: FormBuilder, 
		private _serviciosGenerales:ServiciosGenerales, public snackBar: MatSnackBar, 
		private _route: ActivatedRoute, private _router:Router){
		
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();

		this.formErrors = {
			campo1  : {},
			campo2  : {},
			ciddoc  : {},
			negocio : {}
		}
		this.reporteRango = false;
		this.reporteFecha = false;
		this.mostrar = false;

		this.listaPatrimonios = new Array();
		this.listaPrefijos = new Array();

		this.cnumcont = new OpcionModel("","");
		//this.ciddoc = "";

		this.inicializarForm();
	}


	ngOnInit(){
		this.cargarInfo();

		this.filteredOptions = this.myControl.valueChanges
		.startWith(null)
		.map(val => val ? this.filter(val) : this.listaPatrimonios.slice());
	}



	inicializarForm(){
		this.form = this.formBuilder.group({			
			
			campo1 	: ['', Validators.required],
			campo2 	: ['', Validators.required],
			ciddoc 	: ['', Validators.required],
			negocio : ['', Validators.required]
			
		});
	}


	private cargarInfo(){

		this._serviciosGenerales.get('listaPatrimonios', {param:0}).subscribe(
			result =>{
				for(let x of result){
					this.listaPatrimonios.push(new OpcionModel(x.cnumcont, x.vnombrenegocio));
				}
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los patrimonios", "X");
			});

	}


	consultarPrefijos(){
		this.ciddoc = "";
		this.listaPrefijos = new Array();
		this._serviciosGenerales.get('listaPrefijosContrato', {cnumcont:this.cnumcont.idOpcion}).subscribe(
			result =>{
				for(let x of result){
					this.listaPrefijos.push(new OpcionModel(x.cprefijo,x.cprefijo));
				}


			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los prefijos", "X");
			});
	}


	seleccionPrefijo(registro){
		this.ciddoc = registro;
	}

	filter(val: string)//: string[]
	{
		if(val == null){
			val = "";
		}

		console.log(val);
		return this.listaPatrimonios.filter(option => (option.labelOpcion.toLowerCase().trim() + option.idOpcion.toLowerCase().trim()).indexOf(val.toLowerCase()) != -1);
	}


	eventoConsulta(){
		this.cnumcont.idOpcion = this.cnumcont.labelOpcion.substring(0,this.cnumcont.labelOpcion.indexOf('-'));
		this.consultarPrefijos();


	}




	mostrarCampos(){


		this.mostrar = true;

		this.cnumcont.labelOpcion = '';
		this.eventoConsulta();
		
		if(this.tipoReporte == 1){
			this.valorRango1 = '';
			this.valorRango2 = '';

			this.reporteRango = true;
			this.reporteFecha = false;
		}else if(this.tipoReporte == 2){
			this.valorFecha1 = null;
			this.valorFecha2 = null;

			this.reporteRango = false;
			this.reporteFecha = true;
		}

	}

	openSnackBar(message: string, action: string)
	{
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1 notas");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}




	imprimirFacturas(){

		if(this.cnumcont.idOpcion == ''){
			this.openSnackBarEspecial("El campo negocio es requerido por favor valide","X")
		}else if(this.ciddoc == ''){
			this.openSnackBarEspecial("El campo prefijo es requerido por favor valide","X")
		}
		else if(this.reporteFecha == false && this.reporteRango == false){
			this.openSnackBarEspecial("Debe seleccionar una opcion.", "X");
		}
		else if((this.valorRango1 ==  '' || this.valorRango2 == '') && this.reporteRango == true){
			this.openSnackBarEspecial("Valide los campos del rango de factura ya que estos no pueden estar vacios.", "X");
		}else if((this.valorFecha1 ==  null || this.valorFecha2 == null)  && this.reporteFecha == true){
			this.openSnackBarEspecial("Valide las fechas ya que estas no pueden estar vacias.", "X");
		}else if((isNaN(+this.valorRango1) || isNaN(+this.valorRango2))  && this.reporteRango == true){
			this.openSnackBarEspecial("Valide los campos del rango de factura ya que estos solo aceptan valores numericos.", "X");
		}else {
			
			if(this.reporteRango){
				this.consultarPorRango()
			}else if(this.reporteFecha){
				this.consultarPorFecha()
			}



		}
	}


	consultarPorRango(){


		
		this._serviciosGenerales.descargarArchivo('generarPdfRangos/rango/negocio='+this.cnumcont.idOpcion+
			'&prefijo='+this.ciddoc+
			'&rango1='+this.valorRango1+
			'&rango2='+this.valorRango2
			,null);

	}


	consultarPorFecha(){
		this._serviciosGenerales.descargarArchivo('generarPdfRangos/fecha/negocio='+this.cnumcont.idOpcion+
			'&prefijo='+this.ciddoc+
			'&rango1='+this.valorFecha1.toLocaleDateString().replace('/','-').replace('/','-')+
			'&rango2='+this.valorFecha2.toLocaleDateString().replace('/','-').replace('/','-'),null);
	}


}



// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/ReimpresionFactura/ReimpresionFacturaIndex.component.ts